import {Component, OnInit, Input} from '@angular/core';
import {ChartDataset} from 'chart.js';
import {ThemeService} from 'ng2-charts';

@Component({
    selector: 'app-line-chart',
    templateUrl: './line-chart.component.html',
    styleUrls: ['./line-chart.component.css'],
    providers: [ThemeService]
})
export class LineChartComponent implements OnInit {

    @Input()
    chartData: number[];
    @Input()
    chartLabels: string[];
    @Input()
    chartLabel: string;

    lineChartLegend = true;
    lineChartPlugins = [];
    lineChartType = 'line';
    lineChartData: ChartDataset[];
    lineChartLabels: string[];

    lineChartOptions = {
        responsive: true,
        scales: {
            y: {
                ticks: {
                    stepSize: 1,
                    beginAtZero: true
                }
            }
        }
    };

    constructor() {
    }

    ngOnInit() {
        this.lineChartData = [
            {data: this.chartData, label: this.chartLabel, fill: false, backgroundColor: 'rgba(70, 190, 170,0.2)', borderColor:"rgba(70,190, 170)"},
        ];

        this.lineChartLabels = this.chartLabels;
    }


}
